import { STATUS_TYPE } from '../../../enum';

export interface FindCar {
  isUser?: boolean;
  search?: string;
  limit?: number;
  skip?: number;
  userType?: string;
  bodyType?: string;
  dealerId: string;
}

interface CarImage {
  fileName: string;
  fileType: string;
  id: string;
  key: string;
  url: string;
}

export interface DealerSettings {
  id: string;
  financeAppLink?: string;
  financeAppMessage?: string;
  googleLink?: string;
  financeSmsSendActive?: boolean;
  paperSizeId?: string;
  paperSize?: {
    id: string;
    name: string;
    width: number;
    height: number;
    description?: string;
  };
  promotionalOfferId?: string;
  promotionalOffer?: {
    id: string;
    name: string;
    code: string;
    description?: string;
  };
}

export interface CarBrands {
  id: string;
  title: string;
  refId: string;
}

export interface CarGenerations {
  id: string;
  title: string;
  description: string;
  year: string;
  series: string;
  refId: string;
  brandId: string;
  modelId: string;
  photos: CarImage[];
}

export interface CarModels {
  id: string;
  title: string;
  refId: string;
  brandId: string;
}

interface Dealer {
  id: string;
  firstName: string;
  lastName: string;
  dealerSettings: DealerSettings;
}

export interface Cars {
  id: string;
  title: string;
  price: string;
  description: string;
  vinNumber: string;
  stockNumber: string;
  exterior: string;
  interior: string;
  bodyType: string;
  driveType: string;
  engine: string;
  modelCode: string;
  keyFeatures: string[];
  mileage: string;
  carType: string;
  link: string;
  deletedAt: null | string;
  dealerName: string;
  carBrandId: string;
  carModelId: string;
  carGenerationId: string;
  car_brand: CarBrands;
  car_model: CarModels;
  car_generation: CarGenerations;
  priceBreakup?: {
    id: string | null;
    title: string;
    description: string;
    price: string;
    position: number;
  }[];
  priceBreakups?: {
    id: string | null;
    title: string;
    description: string;
    price: string;
    position: number;
  }[];
  photos: CarImage[];
  userRole: string;
  createdAt: string;
  updatedAt: string;
  availability: string;
  dealer?: Dealer;
}

export interface InitialState {
  data: Cars[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 15,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
